import { useLocalizedContent } from "./components/LocalizedContentContext";
import LocalizationManagerWrapper from "./LocalizationManager";
import LocalizedContentManager from "./LocalizedContentManager";
var src_default = LocalizationManagerWrapper;
import { default as default2 } from "./helpers/createLocalization";
import { default as default3 } from "./helpers/withLocalization";
export {
  LocalizedContentManager,
  default2 as createLocalization,
  src_default as default,
  useLocalizedContent,
  default3 as withLocalization
};
